module.exports = "mutation DeleteProductInsert($id:ID!){deleteProductInsert(id:$id){success}}"